import React, { memo } from 'react';
import { CurrentCondition } from './currentCondition';
import { DateText } from './date';
import { Header } from './header';
import { Links } from './links';
import { LogoDetails } from './logoDetails';

export const WeatherWidgetView = memo(() => {
    
    return (
        <Container>
            <LandingPageWeatherWidgetsContainer>
                <Header />
                <DateText />
                <CurrentCondition />
                <Links />
                <LogoDetails />
            </LandingPageWeatherWidgetsContainer>
        </Container>
    );
});

WeatherWidgetView.displayName = 'WeatherWidgetsView';

import styled from 'styled-components';

const Container = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    margin-top: -16px;
    margin-bottom: -17px;
    padding: 5px;
    width: 100%;
    height: 100vh;
    background-color: #0083C6;
    background: linear-gradient(147.52deg, #000046 -4.15%, #1CB5E0 106.44%);
`;

const LandingPageWeatherWidgetsContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    align-items: center;
    width: 100%;
    height: 100%;
    font-family: Source Sans Pro;
    font-style: normal;
    color: #ffffff;
    font-weight: 500;
`;